export const roles = {
  title: 'Role',
  deleteRole: 'Usuń rolę',
  deletedQuestion: 'Czy na pewno chcesz usunąć rolę: {roleName}',
  editRole: 'Edytuj rolę',
  addRole: 'Utwórz rolę',
  name: 'Nazwa',
  deleteSuccess: 'Usunięto rolę',
  add: 'Utwórz nową rolę',
  titles: {
    flowEngine: 'Uprawnienia Szablonu Konfiguracji',
    users: 'Uprawnienia Użytkownika',
    roles: 'Uprawnienia Administratora',
  },

  createdRole: 'Utworzono rolę',
  savedChanges: 'Zapisano zmiany',
  tooltips: {
    edit: 'Edytuj rolę',
    delete: 'Usuń rolę',
  },
}
